import * as Yup from 'yup';

export const TopTierSchema = Yup.object().shape({
    platinum: Yup.string().min(1, 'Benchmark is required').required('Benchmark is required'),
    gold: Yup.string().min(1, 'Benchmark is required').required('Benchmark is required'),
    silver: Yup.string().min(1, 'Benchmark is required').required('Benchmark is required'),
    risk: Yup.string().min(1, 'Benchmark is required').required('Benchmark is required'),
});

export type TopTierDataType = Yup.InferType<typeof TopTierSchema>;

type InitialValues = {
    platinum: string;
    gold: string;
    silver: string;
    risk: string;

};

export const TopTierInitialValues: InitialValues = {
    platinum: '',
    gold: '',
    silver: '',
    risk: '',
};

export interface TopTierInterface {
    platinum: string;
    gold: string;
    silver: string;
    risk: string;
}
